import type { ChartType } from '@/components/Chart/types/highcharts';
import type { TemplateChartSeries } from '@/pages/Markets/MarketsComponents/types';

export const ChartQueryKeys = {
  all: 'charts',
  chart: (templateChartSeries: TemplateChartSeries[] | undefined, chartType: ChartType) => [
    ChartQueryKeys.all,
    templateChartSeries,
    chartType
  ]
};
